import { render, staticRenderFns } from "./reservedPhone.vue?vue&type=template&id=82889adc&scoped=true&"
import script from "./reservedPhone.vue?vue&type=script&lang=js&"
export * from "./reservedPhone.vue?vue&type=script&lang=js&"
import style0 from "./reservedPhone.vue?vue&type=style&index=0&id=82889adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82889adc",
  null
  
)

export default component.exports